import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateRateCardPositionRequest extends BaseUpdateRequest{
    chargeRate: number;
}